'use client';

import { FC, ReactNode } from 'react';

import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';

type Props = {
    children: ReactNode;
};

const DEFAULT_LOCALE = 'lt-LT';
const CONTENTFUL_ORIGIN = 'https://app.contentful.com/';

export const ContentfulProvider: FC<Props> = ({ children }) => {
    return (
        <ContentfulLivePreviewProvider locale={DEFAULT_LOCALE} targetOrigin={CONTENTFUL_ORIGIN}>
            {children}
        </ContentfulLivePreviewProvider>
    );
};
